<template>
  <section>
    <!-- Componentes externos -->
    <ReprogramarCronograma />
    <SolicitarEjecucionVacacion />
    <VerDetalleUsoVacacion />
    <VerDetalle />
    <VerReporte />
    <VerReprogramaciones />
    <EditarReprogramacionRechazada />

    <h3 class="primary--text">
      <v-icon color="primary">today</v-icon> Vacaciones programadas
    </h3>
    <!-- Seleccionar gestion-->
    <v-flex xs12 md6>
      <v-autocomplete
        :items="lista_gestiones"
        item-text="periodo"
        item-value="periodo"
        label="Seleccione la gestión"
        v-model="periodo_seleccionado"
        @input="cargarVacacionesProgramadas(periodo_seleccionado)"
        required
        outline
        success
        clearable
      ></v-autocomplete>
    </v-flex>
    <!-- Boton filtro -->
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = !filterShow;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton acutualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="cargarVacacionesProgramadas(periodo_seleccionado)"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <!-- Filtros-->
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>
          <div class="filter-item">
            <v-text-field
              label="Nro"
              type="number"
              v-model="form.secuencia"
              @input="filterSecuencia"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha desde"
              type="text"
              v-model="form.fecha_desde"
              @input="filterFechaDesde"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha hasta"
              type="text"
              v-model="form.fecha_hasta"
              @input="filterFechaHasta"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Días programados"
              type="number"
              v-model="form.total_dias"
              @input="filterTotalDias"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Tipo"
              type="text"
              v-model="form.tipo"
              @input="filterTipo"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              v-model="form.estado"
              @input="filterEstado"
            ></v-text-field>
          </div>
          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                  }
                "
              >
                <v-icon small>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :items="lista_vacaciones"
          :headers="headers"
          :disable-initial-sort="true"
          item-key="id"
          :loading="loading"
          no-data-text="No se tiene registros"
          no-results-text="No se encontraron coincidencias"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <!-- Template injectable de la cabecera de la tabla -->

          <template slot="buttons"> </template>
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <tr
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              <!-- Agregar las columnas que consideré necesarias -->
              <td>{{ items.item.secuencia }}</td>
              <td>{{ items.item.fecha_desde }}</td>
              <td>{{ items.item.fecha_hasta }}</td>
              <td>{{ items.item.total_dias }}</td>
              <td>{{ items.item.tipo }}</td>
              <td>
                {{
                  items.item.estado
                    ? items.item.estado
                    : items.item.id_estado == 70
                    ? "Reprogramado Aprobado"
                    : ""
                }}
              </td>
              <td>
                {{
                  items.item.jefe &&
                  (items.item.id_estado == 55 ||
                    items.item.id_estado == 58 ||
                    items.item.id_estado == 68 ||
                    items.item.id_estado == 69)
                    ? items.item.jefe
                    : items.item.jefe_hijo &&
                      (items.item.id_estado_hijo == 55 ||
                        items.item.id_estado_hijo == 58 ||
                        items.item.id_estado_hijo == 68 ||
                        items.item.id_estado_hijo == 69) &&
                      items.item.id_estado != 71 &&
                      items.item.tipo != "R"
                    ? items.item.jefe_hijo
                    : ""
                }}
              </td>
              <td class="text-xs-center">
                {{ items.item.fecha_solicitud }}
              </td>
              <td class="text-xs-center">
                {{ items.item.justificacion_rechazo }}
              </td>
              <td class="text-xs-center">
                <v-chip
                  v-if="
                    items.item.id_estado != 83 && items.item.id_estado != 65
                  "
                  :color="
                    items.item.dias_faltantes > 0 &&
                    items.item.tipo != 'FR' &&
                    items.item.tipo != 'VC'
                      ? '#00D092'
                      : items.item.dias_faltantes < 0 &&
                        items.item.id_estado != 57 &&
                        items.item.id_estado != 65 &&
                        items.item.tipo != 'FR' &&
                        items.item.tipo != 'VC'
                      ? '#d6232e'
                      : items.item.dias_faltantes == 0 &&
                        items.item.tipo != 'FR' &&
                        items.item.tipo != 'VC'
                      ? '#00D092'
                      : ''
                  "
                  dark
                  text-color="wblackhite"
                >
                  {{
                    items.item.dias_faltantes > 0 &&
                    items.item.tipo != "FR" &&
                    items.item.tipo != "VC"
                      ? `Falta ${items.item.dias_faltantes} días para hacer uso de su vacación`
                      : items.item.dias_faltantes < 0 &&
                        items.item.id_estado != 57 &&
                        items.item.id_estado != 65 &&
                        items.item.tipo != "FR" &&
                        items.item.tipo != "VC"
                      ? `Programación vencida`
                      : items.item.dias_faltantes == 0 &&
                        items.item.tipo != "FR" &&
                        items.item.tipo != "VC"
                      ? `Hoy es la fecha del uso de su vacación`
                      : ""
                  }}
                </v-chip>
              </td>
              <td>
                {{ items.item.entregado == "S" ? "ENTREGADO" : "NO ENTREGADO" }}
              </td>
              <td>
                <!-- ver detalle de la programacion -->
                <v-btn
                  color="#3dca24"
                  @click.prevent="verDetalle(items.item)"
                  icon
                  title="Ver detalle"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <!-- VACACIONES REPROGRAMADAS-->
                <v-btn
                  v-if="items.item.id_estado == 57"
                  color="#44deaa"
                  @click.prevent="verReprogramaciones(items.item)"
                  icon
                  title="Ver detalle de reprogramaciones"
                >
                  <v-icon>today</v-icon>
                </v-btn>
                <!-- EJECUCION DE LA VACACION-->
                <v-btn
                  v-if="
                    (items.item.id_estado == 72 ||
                      items.item.id_estado == 70) &&
                      bandera_fecha_corte
                  "
                  color="#44deaa"
                  @click.prevent="solicitarEjecucionVacacion(items.item)"
                  icon
                  title="Enviar solicitud de uso de vacación"
                >
                  <v-icon>send</v-icon>
                </v-btn>

                <!-- REPROGRAMACION DE LA VACACION-->
                <v-btn
                  v-if="
                    (items.item.id_estado == 72 ||
                      items.item.id_estado == 56) &&
                      bandera_fecha_corte
                  "
                  color="blue"
                  @click.prevent="reprogramarCronograma(items.item)"
                  icon
                  title="Reprogramar"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <!-- EDITAR REPROGRAMACION DE LA VACACION POR RECHAZO-->
                <v-btn
                  v-if="items.item.id_estado == 71 && bandera_fecha_corte"
                  color="rgb(145,26,230)"
                  @click.prevent="editarReprogramacionRechazada(items.item)"
                  icon
                  title="Reprogramar reprogramación"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <!-- Reporte de programación -->
                <v-btn
                  v-if="
                    (items.item.id_estado == 65 ||
                      items.item.id_estado == 55 ||
                      items.item.id_estado == 58) &&
                      items.item.tipo == 'P'
                  "
                  color="rgba( 36, 113, 163,0.7)"
                  @click.prevent="verReporte(items.item, 0)"
                  icon
                  title="Ver reporte de programación de vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
                <!-- Reporte de reprogramación -->
                <v-btn
                  v-if="
                    (items.item.id_estado == 65 ||
                      items.item.id_estado == 55 ||
                      items.item.id_estado == 58) &&
                      items.item.tipo == 'R'
                  "
                  color="rgba( 36, 113, 163,0.7)"
                  @click.prevent="verReporte(items.item, 1)"
                  icon
                  title="Ver reporte de reprogramación de vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
                <!-- Reporte de reprogramacionnes -->
                <v-btn
                  v-if="
                    items.item.id_estado == 57 &&
                      (items.item.id_estado_hijo == 70 ||
                        items.item.id_estado_hijo == 55 ||
                        items.item.id_estado_hijo == 58 ||
                        items.item.id_estado_hijo == 65 ||
                        items.item.id_estado_hijo == 68 ||
                        items.item.id_estado_hijo == 69)
                  "
                  color="rgba( 142, 68, 173 ,0.7)"
                  @click.prevent="verReporte(items.item, 2)"
                  icon
                  title="Ver reporte de reprogramaciones de vacación"
                >
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <!-- </crud-table> -->
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table-sin-orden/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table-sin-orden/mixins/crud-table"; // Funciones y Metodos
import ReprogramarCronograma from "./dialogs/ReprogramarCronograma.vue";
import SolicitarEjecucionVacacion from "./dialogs/SolicitarEjecucionVacacion.vue";
import VerDetalleUsoVacacion from "./dialogs/VerDetalleUsoVacacion.vue";
import VerDetalle from "./dialogs/VerDetalle.vue";
import VerReporte from "./dialogs/VerReporte";
import VerReprogramaciones from "./dialogs/VerReprogramaciones";
import EditarReprogramacionRechazada from "./dialogs/EditarReprogramacionRechazada";
// Filtros
import FiltrosVacacion from "./mixins/FiltrosVacacion";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, FiltrosVacacion],
  // Variables iniciales del componente
  data() {
    return {
      url: "vVacacionReprogramadasYParaUsos",
      lista_vacaciones: [],
      loading: false,
      user: this.$storage.get("user"),
      // Variables filtros
      filterShow: true,
      form: {},
      filters: {
        secuencia: "",
        fecha_desde: "",
        fecha_hasta: "",
        total_dias: "",
        tipo: "",
        estado: "",
        nombres: ""
      },
      lista_gestiones: [],
      bandera_fecha_corte: true,
      periodo_seleccionado: new Date().getFullYear(),
      // filters: [
      //   {
      //     field: "secuencia",
      //     label: "Nro",
      //     type: "number",
      //     typeG: "String"
      //   },

      //   {
      //     field: "fecha_desde",
      //     label: "Fecha salida",
      //     type: "text",
      //     typeG: "String"
      //   },
      //   {
      //     field: "fecha_hasta",
      //     label: "Fecha fin",
      //     type: "text",
      //     typeG: "String"
      //   },
      //   {
      //     field: "total_dias",
      //     label: "Días programados",
      //     type: "number",
      //     typeG: "String"
      //   },
      //   {
      //     field: "tipo",
      //     label: "Tipo",
      //     type: "text",
      //     typeG: "String"
      //   },
      //   {
      //     field: "estado",
      //     label: "Estado",
      //     type: "text",
      //     typeG: "String"
      //   }
      // ],
      form: {},
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Nro", value: "secuencia", align: "center" },

        { text: "Fecha desde", value: "fecha_desde", align: "center" },
        { text: "Fecha hasta", value: "fecha_hasta", align: "center" },
        { text: "Días programados", value: "total_dias", align: "center" },
        { text: "Tipo", value: "tipo", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Solicitud enviada a", value: "", align: "center" },
        {
          text: "Fecha de solicitud",
          value: "fecha_solicitud",
          align: "center"
        },
        { text: "Justificación", value: "", align: "center" },
        { text: "Notificación", value: "", align: "center" },
        { text: "Entregado", sortable: false, align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id_vacacion_programada
        fecha_desde
        fecha_hasta
        total_dias
        id_estado
        estado
        bandera
        dias_faltantes
        id_persona
        nombres
        nro_doc
        nro_item
        fecha_solicitud
        saldo_a_reprogramar
        id_unidad
        nombre_unidad
        gestion
        tipo
        secuencia
 `
      // Filtros del componente CrudTable ejemplo:
      // {
      // field: 'Campo definido en Graphql',
      // label: 'Etiqueta del input generado',
      // type: 'text', // Tipo de input en el filtro
      // typeG: 'String' // Tipo definido en Graphql
      // }
      // initData: [
      //   {
      //     state: true,
      //     param: "id_persona",
      //     value: id_persona
      //   },
      //   // {
      //   //   state: true,
      //   //   param: "lista_estados",
      //   //   value: '"72,56,57,58,65,55,70,67,68,69,70"',
      //   // },
      //   {
      //     state: true,
      //     param: "lista_estados",
      //     value: '"72,56,57,58,65,55,70"'
      //   }
      // ],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    await this.obtenerListaGestiones();
    await this.obtenerFechaCorte();
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    // this.onFilter();
    this.$bus.$on("closeDialogVerReporteCronograma", async () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionario", () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioNormal", () => {});
    this.$bus.$on("closeDialogVerReprogramaciones", () => {});
    this.$bus.$on("closeDialogSolicitarUsoVacacionFuncionario", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogReprogramacion", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogEditarReprogramacion", async () => {
      await this.cargarVacacionesProgramadas(this.periodo_seleccionado);
    });
  },
  // Métodos y funciones del componente
  methods: {
    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      try {
        let id_persona = this.$storage.get("user").id_persona;
        this.lista_gestiones = [];
        let resp = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select vev.periodo from vacaciones.v_estado_vacacion vev where vev.id_persona =${parseInt(
                    id_persona
                  )}"){
                  respuesta
                  }
                }	
          `
        });

        if (resp.runQuery.respuesta.length > 0) {
          this.lista_gestiones = resp.runQuery.respuesta;
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    //metodo para obtener la fecha de finalizacion de vacacaiones:
    async obtenerFechaCorte() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select case when now()::date between vp.fecha_corte and coalesce (vp.fecha_aprobacion,now()::date) then false else true end valor from vacaciones.v_programacion vp where vp.gestion =(select max(vp.gestion) from vacaciones.v_programacion vp)"){
                  respuesta
                  }
                }	
              `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          if (respuesta.runQuery.respuesta[0].valor == true) {
            this.bandera_fecha_corte = true;
            return;
          } else {
            this.bandera_fecha_corte = false;
            return;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para listar la tabla
    async cargarVacacionesProgramadas(periodo) {
      if (!this.periodo_seleccionado) {
        return;
      }
      try {
        this.loading = true;
        let resp = await this.$service.graphql({
          query: `
          query{
            vVacacionReprogramadasYParaUsos(id_persona:${
              this.user.id_persona
            },lista_estados:"72,56,57,58,65,55,70,71,83",gestion:${parseInt(
            periodo
          )}){
              rows {
              id_vacacion_programada
              fecha_desde
              fecha_hasta
              total_dias
              id_estado
              estado
              bandera
              dias_faltantes
              id_persona
              nombres
              nro_doc
              nro_item
              fecha_solicitud
              saldo_a_reprogramar
              id_unidad
              nombre_unidad
              gestion
              tipo
              secuencia
              justificacion
              entregado
              jefe
              id_estado_hijo
              motivo_reprogramado
              jefe_hijo
              }
            }
          }
        `
        });
        let lista_tmp = resp.vVacacionReprogramadasYParaUsos.rows;
        // Ordenamos la lista
        // Separamomos negativos y positivos
        var lista_nega = [];
        var lista_posi = [];
        var vacacion_anterior = { id_vacacion: 0 };
        for (let j = 0; j < lista_tmp.length; j++) {
          const element = lista_tmp[j];
          element.rol = 44;
          if (element.dias_faltantes < 0) {
            lista_nega.push(element);
          } else {
            lista_posi.push(element);
          }
        }

        // Ordenamos lista nega descendentemente
        lista_nega.sort(function(a, b) {
          if (a.dias_faltantes < b.dias_faltantes) {
            return 1;
          }
          if (a.dias_faltantes > b.dias_faltantes) {
            return -1;
          }
          return 0;
        });
        // Ordenamos lista posi ascendentemente
        lista_posi.sort(function(a, b) {
          if (a.dias_faltantes > b.dias_faltantes) {
            return 1;
          }
          if (a.dias_faltantes < b.dias_faltantes) {
            return -1;
          }
          return 0;
        });

        let lista_ordenada_repetida = lista_posi.concat(lista_nega);
        //eliminamos repetidos
        let unique = {};
        lista_ordenada_repetida = lista_ordenada_repetida.filter(obj => {
          if (!unique[obj.id_vacacion_programada]) {
            unique[obj.id_vacacion_programada] = true;
            return true;
          }
          return false;
        });

        this.lista_vacaciones = lista_ordenada_repetida;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item, valor) {
      item.reprogramacion = valor; //programacion=0,repro=1 , reprogramaciones padre
      console.log("valor", item.reprogramacion);
      item.correlativo = item.secuencia;
      item.gestion = item.fecha_desde.substring(6, 10);
      this.$bus.$emit("openDialogVerReporte", item);
    },
    verReprogramaciones(item) {
      this.$bus.$emit("openDialogVerReprogramaciones", item);
    },
    solicitarEjecucionVacacion(item) {
      // item.funcionario = this.funcionario;
      // item.saldo = this.saldo;
      this.$bus.$emit("openDialogSolicitarEjecucionVacacion", item);
    },
    reprogramarCronograma(item) {
      item.rol = 42;
      this.$bus.$emit("openDialogReprogramarCronograma", item);
    },
    editarReprogramacionRechazada(item) {
      item.rol = 42;
      this.$bus.$emit("openDialogEditarReprogramacion", item);
    },
    verDetalle(item) {
      if (item.tipo == "P") {
        this.$bus.$emit("openDialogVerDetalleUsoVacacion", item);
      } else {
        this.$bus.$emit("openDialogVerDetalleUsoFuncionarioNormal", item);
      }
    }
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    ReprogramarCronograma,
    VerDetalleUsoVacacion,
    VerDetalle,
    SolicitarEjecucionVacacion,
    VerReporte,
    VerReprogramaciones,
    EditarReprogramacionRechazada
  }
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
h3 {
  color: rgb(1, 3, 85);
}
#celdaP {
  background: rgba(103, 236, 179, 0.3);
}
#celdaR {
  background: rgba(241, 217, 111, 0.3);
}
#celdaVC {
  background: rgba(189, 143, 238, 0.3);
}
#celdaFR {
  background: rgba(141, 208, 240, 0.3);
}
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/Index.vue